import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { publicGet } from "@/lib/api";

const SITE = "Club Prezzi";
const DEFAULT_IMG = "https://static.prod-images.emergentagent.com/jobs/8a990b7d-87bf-4959-9ab4-9392f63d36b3/images/56fdd763cb546969e4ae5477ded8e26d664069c17f330fb9cd98ac7963395892.jpeg";
let verification = null;

export function Seo({ title, description, image, type = "website", jsonLd, noindex }) {
  const { pathname } = useLocation();
  const [gsv, setGsv] = useState(verification);
  useEffect(() => {
    document.querySelectorAll("head [data-static]").forEach((el) => el.remove());
    if (verification !== null) return;
    publicGet("/public/seo").then((d) => { verification = d.google_site_verification || ""; setGsv(verification); }).catch(() => {});
  }, []);
  const url = `${window.location.origin}${pathname}`;
  const full = title ? `${title} | ${SITE}` : `${SITE} · Confronta prezzi, guadagna punti, risparmia`;
  return (
    <Helmet>
      <html lang="it" />
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {gsv && <meta name="google-site-verification" content={gsv} />}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image || DEFAULT_IMG} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || DEFAULT_IMG} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
